var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated"},[_c('h3',[_vm._v("\n    Analytes\n  ")]),_c('analyte-table',{attrs:{"analytes":_vm.analytes,"show_columns":[
      'name',
      'abbrev',
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }